export enum DiagnosisCategory {
  IBD = 'IBD',
  IBS = 'IBS',
  Other = 'Other',
  UpperGI = 'Upper GI',
}

export type Diagnosis = {
  id: string;
  diagnosis: string;
  category: DiagnosisCategory;
  core: boolean;
};

export enum MeetingTypeId {
  InitialConsultation = 'Initial Consultation',
  InitialCoachCall = 'Initial Coach Call',
}

export type MeetingType = {
  id: string;
  length: number;
  name: MeetingTypeId;
};

export type ProviderTime = {
  provider_id: number
  time: string // ISO string
}

export type AvailabilityEntry = {
  date: string;
  times: (string | ProviderTime)[]
};

export type AvailabilityResponse = {
  meeting_type: MeetingType;
  availability: AvailabilityEntry[]
};

export enum CareModel {
  DigitalOnly = "Digital-only",
  CoachOnly = "Coach-only",
  Collaborative = "Collaborative"
}

// Mirrors Users.CurrentStatus on the backend, which validates the value sent
// under `current_status` on POST /register.
export enum CurrentStatusAnswer {
  Newbie = 'newbie',
  Learning = 'learning',
  NeedMoreHelp = 'need_more_help',
  Maintaining = 'maintaining',
  Other = 'other',
}

// `description` carries the free text, and the backend requires it when the
// answer is `Other`.
export type CurrentStatus = {
  answer: CurrentStatusAnswer;
  description?: string;
};
